import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import { middlewares } from './middlewares';
import { rootReducer } from './rootReducer';

const combinedReducers = combineReducers(rootReducer());
export const store = createStore(
    combinedReducers,
    composeWithDevTools(applyMiddleware(...middlewares)),
);
